import { render, staticRenderFns } from "./TableTitle.vue?vue&type=template&id=4905ae3d&scoped=true&"
import script from "./TableTitle.vue?vue&type=script&lang=js&"
export * from "./TableTitle.vue?vue&type=script&lang=js&"
import style0 from "./TableTitle.vue?vue&type=style&index=0&id=4905ae3d&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4905ae3d",
  null
  
)

export default component.exports